/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const billIDOption = [
  {
    value: "01GTKT",
    label: "01GTKT",
    disabled: false,
  },
  {
    value: "02GTTT",
    label: "02GTTT",
    disabled: false,
  },
  {
    value: "07KPTQ",
    label: "07KPTQ",
    disabled: false,
  },
  {
    value: "03XKNP",
    label: "03XKNP",
    disabled: false,
  },
  {
    value: "04HGDL",
    label: "04HGDL",
    disabled: false,
  },
  {
    value: "01BHDT",
    label: "01BHDT",
    disabled: false,
  },
  {
    value: "01/",
    label: "01/",
    disabled: false,
  },
  {
    value: "02/",
    label: "02/",
    disabled: false,
  },
  {
    value: "TT120",
    label: "TT120",
    disabled: false,
  },
  {
    value: "01TEDB",
    label: "01TEDB",
    disabled: false,
  },
  {
    value: "01VEDB",
    label: "01VEDB",
    disabled: false,
  },
  {
    value: "01THDB",
    label: "01THDB",
    disabled: false,
  },
  {
    value: "02TEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02VEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02THDB",
    label: "02TEDB",
    disabled: false,
  },
];

const noteOption = [
  {
    value: "Hóa đơn chưa TBPH",
    label: "Hóa đơn chưa TBPH",
    disabled: false,
  },
  {
    value: "Hóa đơn chưa sử dụng",
    label: "Hóa đơn chưa sử dụng",
    disabled: false,
  },
  {
    value: "Hóa đơn đã viết chưa báo cáo sử dụng",
    label: "Hóa đơn đã viết chưa báo cáo sử dụng",
    disabled: false,
  },
  {
    value: "Hóa đơn đã viết và đã báo cáo sử dụng kỳ trước",
    label: "Hóa đơn đã viết và đã báo cáo sử dụng kỳ trước",
    disabled: false,
  },
  {
    value: "Hóa đơn mua hàng",
    label: "Hóa đơn mua hàng",
    disabled: false,
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: 1,
      bg: true,
    },
    mst: {
      type: "input",
      value: null,
      bg: false,
    },
    name: {
      type: "input",
      value: null,
      bg: false,
    },
    number: {
      type: "input",
      value: null,
      bg: false,
    },
    date: {
      type: "input",
      value: null,
      bg: false,
    },
    billId: {
      type: "select",
      value: null,
      bg: false,
      option: billIDOption,
    },
    billName: {
      type: "input",
      value: null,
      bg: false,
    },
    denominatorSymbolBill: {
      type: "input",
      value: null,
      bg: false,
    },
    symbolBill: {
      type: "input",
      value: null,
      bg: false,
    },
    total: {
      type: "input",
      value: 0,
      bg: true,
    },

    beginningFrom: {
      type: "input",
      value: null,
      bg: false,
    },
    beginningTo: {
      type: "input",
      value: null,
      bg: false,
    },
    inPeriodFrom: {
      type: "input",
      value: null,
      bg: false,
    },
    inPeriodTo: {
      type: "input",
      value: null,
      bg: false,
    },
    totalUsedFrom: {
      type: "input",
      value: null,
      bg: true,
    },
    totalUsedTo: {
      type: "input",
      value: null,
      bg: true,
    },
    totalUsedSum: {
      type: "input",
      value: 0,
      bg: true,
    },
    totalUsed: {
      type: "input",
      value: 0,
      bg: false,
    },
    deleteQuantity: {
      type: "input",
      value: 0,
      bg: true,
    },
    deleteNumber: {
      type: "input",
      value: null,
      bg: false,
    },
    lostQuantity: {
      type: "input",
      value: 0,
      bg: true,
    },
    lostNumber: {
      type: "input",
      value: null,
      bg: false,
    },
    cancelQuantity: {
      type: "input",
      value: 0,
      bg: true,
    },
    cancelNumber: {
      type: "input",
      value: null,
      bg: false,
    },

    lastFrom: {
      type: "input",
      value: null,
      bg: true,
    },
    lastTo: {
      type: "input",
      value: null,
      bg: true,
    },
    lastSum: {
      type: "input",
      value: 0,
      bg: true,
    },
  },
];
export default function BillBc26Table({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: newIdValue,
        bg: true,
      },
      mst: {
        type: "input",
        value: null,
        bg: false,
      },
      name: {
        type: "input",
        value: null,
        bg: false,
      },
      number: {
        type: "input",
        value: null,
        bg: false,
      },
      date: {
        type: "input",
        value: null,
        bg: false,
      },
      billId: {
        type: "select",
        value: null,
        bg: false,
        option: billIDOption,
      },
      billName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominatorSymbolBill: {
        type: "input",
        value: null,
        bg: false,
      },
      symbolBill: {
        type: "input",
        value: null,
        bg: false,
      },
      total: {
        type: "input",
        value: 0,
        bg: true,
      },

      beginningFrom: {
        type: "input",
        value: null,
        bg: false,
      },
      beginningTo: {
        type: "input",
        value: null,
        bg: false,
      },
      inPeriodFrom: {
        type: "input",
        value: null,
        bg: false,
      },
      inPeriodTo: {
        type: "input",
        value: null,
        bg: false,
      },
      totalUsedFrom: {
        type: "input",
        value: null,
        bg: true,
      },
      totalUsedTo: {
        type: "input",
        value: null,
        bg: true,
      },
      totalUsedSum: {
        type: "input",
        value: 0,
        bg: true,
      },
      totalUsed: {
        type: "input",
        value: 0,
        bg: false,
      },
      deleteQuantity: {
        type: "input",
        value: 0,
        bg: true,
      },
      deleteNumber: {
        type: "input",
        value: null,
        bg: false,
      },
      lostQuantity: {
        type: "input",
        value: 0,
        bg: true,
      },
      lostNumber: {
        type: "input",
        value: null,
        bg: false,
      },
      cancelQuantity: {
        type: "input",
        value: 0,
        bg: true,
      },
      cancelNumber: {
        type: "input",
        value: null,
        bg: false,
      },

      lastFrom: {
        type: "input",
        value: null,
        bg: true,
      },
      lastTo: {
        type: "input",
        value: null,
        bg: true,
      },
      lastSum: {
        type: "input",
        value: 0,
        bg: true,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          3 Các loại hóa đơn khác
        </Typography>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="4">
                STT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="4">
                Mã hóa đơn
              </Th>
              <Th style={{ textAlign: "center", width: "150px" }} rowSpan="4">
                Tên loại hóa đơn
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="4">
                Ký hiệu mẫu hóa đơn
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="4">
                Ký hiệu hóa đơn
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="5">
                Số tồn đầu kỳ,mua/phát hành trong kỳ
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="10">
                Số sử dụng,xóa bỏ,mất,hủy trong kỳ
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="6" rowSpan="2">
                Tồn cuối kỳ
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="3">
                Tổng số
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Số tồn đầu kỳ
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Số mua phát hành trong kỳ
              </Th>

              <Th style={{ textAlign: "center" }} colSpan="3">
                Tổng số sử dụng, xóa bỏ,mất,hủy{" "}
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="7">
                Trong đó
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Từ số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Đến số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Từ số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Đến số
              </Th>

              <Th style={{ textAlign: "center" }} rowSpan="2">
                Đến số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Từ số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Cộng
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số lượng đã sử dụng
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Xóa bỏ
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2" rowSpan="1">
                {" "}
                Mất
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Hủy
              </Th>

              <Th style={{ textAlign: "center" }} rowSpan="2">
                Đến số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Từ số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số lượng
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Số lượng</Th>
              <Th style={{ textAlign: "center" }}>Số</Th>

              <Th style={{ textAlign: "center" }}>Số lượng</Th>
              <Th style={{ textAlign: "center" }}>Số</Th>

              <Th style={{ textAlign: "center" }}>Số lượng</Th>
              <Th style={{ textAlign: "center" }}>Số</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>(13)</Th>
              <Th style={{ textAlign: "center" }}>(14)</Th>
              <Th style={{ textAlign: "center" }}>(15)</Th>
              <Th style={{ textAlign: "center" }}>(16)</Th>
              <Th style={{ textAlign: "center" }}>(17)</Th>
              <Th style={{ textAlign: "center" }}>(18)</Th>
              <Th style={{ textAlign: "center" }}>(19)</Th>
              <Th style={{ textAlign: "center" }}>(20)</Th>
              <Th style={{ textAlign: "center" }}>(21)</Th>
              <Th style={{ textAlign: "center" }}>(22)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row?.id?.value}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.billId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billId.bg ? (
                      row.billId.value
                    ) : row.billId?.type === "select" ? (
                      <SelectTable
                        name="billId"
                        id={row.id.value}
                        option={row.billId.option ? row.billId.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="billId"
                        value={row.billId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.billName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billName?.type !== "input" ? (
                      row.billName.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="billName"
                        value={row.billName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.denominatorSymbolBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.denominatorSymbolBill?.type !== "input" ? (
                      row.denominatorSymbolBill.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="denominatorSymbolBill"
                        value={row.denominatorSymbolBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.symbolBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.symbolBill?.type !== "input" ? (
                      row.symbolBill.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="symbolBill"
                        value={row.symbolBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.total.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.total?.type !== "input" ? (
                      row.total.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="total"
                        value={row.total.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.beginningFrom.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.beginningFrom?.type !== "input" ? (
                      row.beginningFrom.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="beginningFrom"
                        value={row.beginningFrom.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.beginningTo.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.beginningTo?.type !== "input" ? (
                      row.beginningTo.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="beginningTo"
                        value={row.beginningTo.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.inPeriodFrom.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.inPeriodFrom?.type !== "input" ? (
                      row.inPeriodFrom.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="inPeriodFrom"
                        value={row.inPeriodFrom.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.inPeriodTo.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.inPeriodTo?.type !== "input" ? (
                      row.inPeriodTo.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="inPeriodTo"
                        value={row.inPeriodTo.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalUsedFrom.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalUsedFrom?.type !== "input" ? (
                      row.totalUsedFrom.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="totalUsedFrom"
                        value={row.totalUsedFrom.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalUsedTo.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalUsedTo?.type !== "input" ? (
                      row.totalUsedTo.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="totalUsedTo"
                        value={row.totalUsedTo.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalUsedSum.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalUsedSum?.type !== "input" ? (
                      row.totalUsedSum.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="totalUsedSum"
                        value={row.totalUsedSum.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalUsed.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalUsed?.type !== "input" ? (
                      row.totalUsed.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="totalUsed"
                        value={row.totalUsed.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.deleteQuantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.deleteQuantity?.type !== "input" ? (
                      row.deleteQuantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="deleteQuantity"
                        value={row.deleteQuantity.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.deleteNumber.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.deleteNumber?.type !== "input" ? (
                      row.deleteNumber.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="deleteNumber"
                        value={row.deleteNumber.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.lostQuantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.lostQuantity?.type !== "input" ? (
                      row.lostQuantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="lostQuantity"
                        value={row.lostQuantity.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.lostNumber.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.lostNumber?.type !== "input" ? (
                      row.lostNumber.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="lostNumber"
                        value={row.lostNumber.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.cancelQuantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.cancelQuantity?.type !== "input" ? (
                      row.cancelQuantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="cancelQuantity"
                        value={row.cancelQuantity.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.cancelNumber.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.cancelNumber?.type !== "input" ? (
                      row.cancelNumber.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="cancelNumber"
                        value={row.cancelNumber.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.lastFrom.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.lastFrom?.type !== "input" ? (
                      row.lastFrom.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="lastFrom"
                        value={row.lastFrom.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.lastTo.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.lastTo?.type !== "input" ? (
                      row.lastTo.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="lastTo"
                        value={row.lastTo.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.lastSum.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.lastSum?.type !== "input" ? (
                      row.lastSum.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="lastSum"
                        value={row.lastSum.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
